// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import baEntity from './entities/ba.json';
import baMenu from '../pages/ba/menu.json';
import baFullForm from '../pages/ba/forms/full.json';
import baContextForm from '../pages/ba/forms/context.json';
import baMiniForm from '../pages/ba/forms/mini.json';
import baLookupForm from '../pages/ba/forms/lookup.json';
import baTableView from '../pages/ba/views/table.json';
import baStagesView from '../pages/ba/views/stages.json';
import baCardsView from '../pages/ba/views/cards.json';
import baInlineView from '../pages/ba/views/inline.json';
import baBacklogView from '../pages/ba/views/backlog.json';
import baSplitView from '../pages/ba/views/split.json';
import baCalendarView from '../pages/ba/views/calendar.json';
import baDashboardView from '../pages/ba/views/dashboard.json';

/** Тип запису «Елемент аналізу» зі сторінками пакета: меню, форми та подання з pages/ba/. */
export const baDefinition: IRecordTypeDefinition = {
  ...baEntity,
  views: assembleViewSet({
      table: baTableView,
      stages: baStagesView,
      cards: baCardsView,
      inline: baInlineView,
      backlog: baBacklogView,
      split: baSplitView,
      calendar: baCalendarView,
      dashboard: baDashboardView,
  }),
  form: baFullForm,
  forms: { full: baFullForm, context: baContextForm, mini: baMiniForm, lookup: baLookupForm },
  menu: baMenu,
} as IRecordTypeDefinition;
